module.exports = __webpack_public_path__ + "static/media/18ECA45.63972915.jpg";